import { atom } from "jotai";
import { createDerivedWritableAtom } from "../utils";
import { logger } from "../datadog/logger";
import { UserType } from "../types";

export type AuthState = {
  authedAtTimestamp: number | null;
  needsReLogin: boolean;
  userType: UserType | null;
};

export const authAtom = atom<AuthState>({
  authedAtTimestamp: null,
  needsReLogin: false,
  userType: null,
});

/**
 * Stores the time that the user last completed the app's
 * authentication/authorization flow. This will be likely be slightly different
 * than the actual login time.
 *
 * ⚠️ This value cannot be reset after being set.
 */
export const authedAtTimestampAtom = atom(
  (get) => {
    return get(authAtom).authedAtTimestamp;
  },
  (_get, set, timestamp: number | null) => {
    if (!timestamp) {
      // This is because several flows rely on this to track whether a user authed
      // before
      logger.error(
        "Must go through the logout flow to reset the authed-at timestamp.",
      );
      return;
    }
    set(authAtom, (prev) => ({
      ...prev,
      authedAtTimestamp: timestamp,
    }));
  },
);
authedAtTimestampAtom.debugLabel = "authedAtTimestampAtom";

export const needsReLoginAtom = createDerivedWritableAtom(
  authAtom,
  "needsReLogin",
);

export const userTypeAtom = createDerivedWritableAtom(authAtom, "userType");
